import { PRIMARY_KEYS } from "src/pages/ad-studio/insights/performance/view/constants";
import { PerformanceViewPrimitive } from "src/pages/ad-studio/insights/performance/view/performance-view-primitive";
import type {
  Kind,
  OpenedIn,
  Page,
  RowOf,
  SortedColumn,
} from "src/pages/ad-studio/insights/performance/view/types";

export type ListDrilldownTableAction<K extends Kind> =
  | SortedColumn
  | { kind: "ListDrilldownTableAction/drilled-down"; opened: OpenedIn<K> };

type ListDrilldownTableProps<K extends Kind> = {
  page: Page<K>;
  performAction: (action: ListDrilldownTableAction<K>) => void;
};

/** A page of a list whose rows drill down into what they are when clicked. */
export const ListDrilldownTable = <K extends Kind>({
  page,
  performAction,
}: ListDrilldownTableProps<K>) => (
  <PerformanceViewPrimitive.DrilldownTable<RowOf<K>>
    rows={page.list.rows}
    columns={page.columns}
    primaryKey={PRIMARY_KEYS[page.kind]}
    empty={page.empty}
    performAction={(action) => {
      switch (action.kind) {
        case "PerformanceViewAction/drilled-down": {
          return performAction({
            kind: "ListDrilldownTableAction/drilled-down",
            opened: { kind: page.kind, list: page.list, row: action.row },
          });
        }
        case "PerformanceViewAction/sorted-column": {
          return performAction(action);
        }
        default: {
          return action satisfies never;
        }
      }
    }}
  />
);
